module.exports = __webpack_public_path__ + "static/10-b2a80aba366ca0581b7e79e3bc62f10b.jpg";